import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

export default function Products() {
    const {
        products,
        loading
    } = useAppStateSelector(state => ({ products: state.response.products, loading: state.loading }))

    useEffect(() => {
        if (loading) return
        const swat = window?._swat
        if (!swat || typeof swat.initializeActionButtons !== "function") return
    
        const raf = requestAnimationFrame(() => {
            swat.initializeActionButtons("body")
        })
    
        return () => cancelAnimationFrame(raf)
    }, [loading, products?.hits?.length])

    return (
        <div class="ns-d-flex ns-flex-wrap ns-gap-2 ns-gap-l-sm ns-px-l-xl" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </div>
    )
}
